export default {
  REGISTER: {
    search: '?modal=auth&tab=register'
  },
  LOGIN: {
    search: '?modal=auth&tab=login'
  },
  LOGOUT: {
    search: '?modal=logout'
  },
  FORGOT_PASSWORD: {
    search: '?modal=forgotPassword'
  },
  WALLET: {
    search: '?modal=wallet&tab=deposit'
  },
  DEPOSIT: {
    search: '?modal=wallet&tab=deposit'
  },
  BUY_GOLD: {
    search: '?modal=wallet&tab=buy-gold'
  },
  CHAT_RULES: {
    search: '?modal=chatRules'
  },
  USER: {
    search: '?modal=user'
  },
  CREATE_DUEL: {
    search: '?modal=createDuel'
  },
  START_DUEL: {
    search: '?modal=startDuel'
  },
  DELETE_DUEL: {
    search: '?modal=deleteDuel'
  },
  DUEL: {
    search: '?modal=acceptDuel'
  },
  RACE: {
    search: '?modal=race'
  },
  LINK_ACCOUNT: {
    search: '?modal=linkAccount'
  },
  SET_USERNAME: {
    search: '?modal=setUsername'
  }
}

export const requireAuthModals = [
  'logout',
  'wallet',
  'createDuel',
  'acceptDuel'
]